/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceData
 */
export interface InvoiceData {
    /**
     * 
     * @type {string}
     * @memberof InvoiceData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceData
     */
    number?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceData
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceData
     */
    dueAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceData
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceData
     */
    amountPaid?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceData
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceData
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceData
     */
    invoicePdfUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceData
     */
    hostedInvoiceUrl?: string | null;
}

/**
 * Check if a given object implements the InvoiceData interface.
 */
export function instanceOfInvoiceData(value: object): value is InvoiceData {
    return true;
}

export function InvoiceDataFromJSON(json: any): InvoiceData {
    return InvoiceDataFromJSONTyped(json, false);
}

export function InvoiceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'number': json['number'] === undefined ? undefined : json['number'] === null ? null : json['number'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'dueAt': json['dueAt'] === undefined ? undefined : json['dueAt'] === null ? null : (new Date(json['dueAt'])),
        'total': json['total'] == null ? undefined : json['total'],
        'amountPaid': json['amountPaid'] == null ? undefined : json['amountPaid'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'status': json['status'] === undefined ? undefined : json['status'] === null ? null : json['status'],
        'invoicePdfUrl': json['invoicePdfUrl'] === undefined ? undefined : json['invoicePdfUrl'] === null ? null : json['invoicePdfUrl'],
        'hostedInvoiceUrl': json['hostedInvoiceUrl'] === undefined ? undefined : json['hostedInvoiceUrl'] === null ? null : json['hostedInvoiceUrl'],
    };
}

export function InvoiceDataToJSON(json: any): InvoiceData {
    return InvoiceDataToJSONTyped(json, false);
}

export function InvoiceDataToJSONTyped(value?: InvoiceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': value['number'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
        'total': value['total'],
        'amountPaid': value['amountPaid'],
        'currency': value['currency'],
        'status': value['status'],
        'invoicePdfUrl': value['invoicePdfUrl'],
        'hostedInvoiceUrl': value['hostedInvoiceUrl'],
    };
}

